<template>
  <div class="home-cont">
    <!-- 左侧导航开始 -->
    <div class="home-nav unselect" :class="{'close': isCollapse}">
      <el-drawer title="设置"
        :visible.sync="seting.show"
        direction="rtl" >
      </el-drawer>

      <GeminiScrollbar class="home-nav-scroll-bar">

      <div class="logo" >
        <div class="logo-in" v-show="! isCollapse" style="padding: 15px 0">
          <img class="big" src="@/assets/logo3.png" alt="">
        </div>
        <div class="logo-in"  v-show="isCollapse">
          <img class="small" src="@/assets/logo.png" alt="">
        </div>
      </div>
      
      <div class="home-nav-ctrl" @click="ctrlCollapse">
        <i class="el-icon-arrow-left" v-show="! isCollapse"></i>
        <i class="el-icon-arrow-right" v-show="isCollapse"></i>
      </div>
      
      <!-- 菜单渲染开始 -->
      <div class="nav-cont unselect">
        <el-menu 
        :default-active="active"
        class="el-menu-vertical-demo" 
        :collapse="isCollapse"
        background-color="#545c64"
        text-color="#fff"
        active-text-color="#e97c1b" >
          <template v-for="item in menu.tree" :index="item.id">
            <el-menu-item v-if="! item.son || item.son.length == 0" :disabled="item.id !=='e337f753af42476783c7f7e826c07893'" :key="item.id" :index="item.url" @click="navClick(item)">
              <i v-if="item.icon" :class="item.icon"></i>
              <i v-else class="el-icon-link"></i>
              <template slot="title"><span slot="title">{{item.name}}</span></template>
            </el-menu-item>
            <el-submenu v-if="item.son && item.son.length > 0" :key="item.id" :index="item.url">
              <template slot="title">
                <i v-if="item.icon" :class="item.icon"></i>
                <i v-else class="el-icon-collection-tag"></i>
                <span slot="title">{{item.name}}</span>
              </template>
              <template v-for="obj in item.son">
                <el-menu-item v-if="! obj.son || obj.son.length == 0" :key="obj.id" :index="obj.url" @click="navClick(obj)">{{obj.name}}</el-menu-item>
                <el-submenu  v-if="obj.son && obj.son.length > 0" :key="obj.id" :index="obj.id">
                  <span slot="title"><i class="el-icon-collection-tag"></i> <span slot="title">{{obj.name}}</span></span>
                  <el-menu-item v-for="(data, jndex) in obj.son" :key="jndex" :index="data.url" @click="navClick(data)">{{data.name}}</el-menu-item>
                </el-submenu>
              </template>
            </el-submenu>
          </template>
        </el-menu>
      </div>
      <!-- 菜单渲结束 -->

      </GeminiScrollbar>
    </div>
    <!-- 左侧导航结束 -->
    <!-- 右侧内容开始 -->
    <div class="home-body">
      <!-- 标签栏开始 -->
      <div class="body-tabs unselect">
        <el-popover
          placement="bottom"
          width="150"
          trigger="hover">

          <div class="more-cont">
            <ul>
              <li @click="signOut">退出系统</li>
              <li @click="setUserPassword">修改密码</li>
            </ul>
          </div>

          <userPassword ref="userPassword" @change="signOut"></userPassword>
          
          <div class="tabs-right tabs-user" slot="reference">
            <img v-show="! $init.user.imageUrl" src="@/assets/user.jpeg" alt="头像" >
            <img v-show="$init.user.imageUrl" :src="$init.imgIp + $init.user.imageUrl" alt="头像" >
          </div>
        </el-popover>

        <!-- <div class="tabs-right" @click="seting.show = true">
          <i class="el-icon-s-operation" title="设置"></i>
        </div> -->

        <!-- 右键菜单开始 -->
        <v-contextmenu ref="contextmenu" @contextmenu="contextmenu">
          <v-contextmenu-item @click="contextDelTabNow">关闭</v-contextmenu-item>
          <v-contextmenu-item @click="contextDelTabOther" v-show="tabs.list.length > 1">关闭其他菜单</v-contextmenu-item>
          <v-contextmenu-item @click="contextDelTabRight" v-show="this.contextNum < tabs.list.length -1">关闭右侧所有页面</v-contextmenu-item>
          <v-contextmenu-item @click="contextDelTabAll">关闭全部菜单</v-contextmenu-item>
        </v-contextmenu>
        <!-- 右键菜单结束 -->

        <!-- 标签列表开始 -->
        <div class="tabs-cont" ref="tabsCont">
          <GeminiScrollbar class="tabs-cont-scroll-bar">
            <div class="tabs-list unselect">
              <!-- <el-tag class="tag"
                v-contextmenu:contextmenu
                :disable-transitions="false"
                :effect="tabs.now == 0 ? 'dark' : 'light'"
                @click="navClick()" >
                <i class="iocnfont el-icon-s-home"></i>
              </el-tag> -->
              <el-tag  v-for="(item, index) in tabs.list" :key="index" class="tag"
                v-contextmenu:contextmenu
                closable
                :disable-transitions="false"
                :effect="tabs.now == item.id ? 'dark' : 'light'"
                @click="navClick(item)"
                @close="delTab(item)">
                {{item.name}}
              </el-tag>
            </div>
          </GeminiScrollbar>
        </div>
        <!-- 标签列表结束 -->
      </div>
      <!-- 标签栏结束 -->
      <!-- 内容开始 -->
      <div class="body-cont">
        <slot></slot>
      </div>
      <!-- 内容结束 -->
    </div>
    <!-- 右侧内容结束 -->
  </div>
</template>

<script>
import userPassword from '@/views/seting/userPassword'
export default {
  name: 'Header',
  components: {
    userPassword
  },
  data () {
    return {
      tabLeft: 0, // 标签列表定位
      contextNum: 0, // 当前右键菜单
      menu: {
        list: this.$init.menu, 
        tree: this.$init.getMenuTree(), // 菜单树
      },
      isCollapse: localStorage.getItem('isCollapse') == 'true' ? true : false,
      nowLang: 'zh-CN',
      active: '', // 选中标签
      seting: {
        show: false,
      },
    }
  },
  created () {
    
  },
  methods: {
    // 导航栏 - 展开或关闭 
    ctrlCollapse () {
      if(this.isCollapse ){
        this.isCollapse = false;
        window.localStorage.setItem('isCollapse','false')
      }else{
        this.isCollapse = true;
        window.localStorage.setItem('isCollapse', 'true')
      }
    },
    // 切换语言
    switchLanguage () {
      this.$i18n.locale == 'zh-CN' ? this.$i18n.locale = 'en-US' : this.$i18n.locale = 'zh-CN'
      console.log(this.$t('lang.lang'))
    },
    // 退出登陆
    signOut () {
      sessionStorage.clear();
      this.$init.token = {};
      this.$init.user = {};
      this.$init.role = {};
      // TODO 没权限认证封印
      // this.$init.menu = [];
      this.$cookies.remove('token');
      this.$router.push('/login');
    },
    /**
     * 修改密码
     */
    setUserPassword () {
      this.$refs.userPassword.dialogFormVisible = true;
    },
    // 点击菜单
    navClick (obj = {id: '0', name: '首页'}) {
      if(obj.id !== 'e337f753af42476783c7f7e826c07893') {
        // this.$message.error('网络错误')
        return
      }
      this.$router.push({
        path: '/claimManagement/claimList'
      })
      // this.$store.commit('addTab', obj)
    },
    // 删除标签
    delTab (obj) {
      this.$store.commit('delTab', obj)
    },
    // 右键菜单
    contextmenu (vnode) {
      this.contextNum = vnode.key;
    },
    // 关闭当前菜单
    contextDelTabNow () {
      this.$store.commit('delTab', this.tabs.list[this.contextNum]);
    },
    // 关闭其他菜单
    contextDelTabOther () {
      this.$store.commit('delTabOther', this.contextNum);
    },
    // 关闭右侧菜单
    contextDelTabRight () {
      this.$store.commit('delTabRight', this.contextNum);
    },
    // 关闭所有菜单
    contextDelTabAll () {
      this.$store.commit('delTabAll');
    }
  },
  computed: {
    // 标签
    tabs () {
      return this.$store.state.tabs;
    },
  },
  watch: {
    '$store.state.tabs.now' (val) { 
      if(val != '0'){
        const resultObj = {} = this.tabs.list.find((item) => item.id == val)
        this.$router.push({
          path: resultObj.url ? resultObj.url : '',
          query: resultObj.query
        })
      }else{
        this.$router.push('/home')
      }
    },
    '$route.path' (str) {
      this.active = str;
    },
  }
}
</script>

<style lang="scss" scoped type="text/css">
.home-cont{
  height: 100%;
  width: 100%;
  display: flex;
}
.home-nav{
  z-index: 10;
  transition: width 0.4s;
  height: 100%;
  width: 222px;
  overflow: auto;
  background-color: #545c64;
  color: #fff;
  .logo{
    padding: 0px 0 10px 0;
    .logo-in{
      /* background: $color-theme1; */
      background:#fff;
      border-right: 1px solid whitesmoke;
    }
    .big{
      display: block;
      // width: 40%;
      height: 40px;
      cursor: pointer;
      margin: 0 auto;
    }
    .small{
      display: block;
      // width: 50px;
      margin: 0 auto;
      height: 40px;
    }
  }

  .home-nav-scroll-bar{
    height: 100%;
  }
  .home-nav-ctrl{
    height: 40px;
    line-height: 40px;
    text-align: center;
    font-size: 18px;
    font-weight: 700;
    cursor: pointer;
  }
  &.close{
    width: 64px;
    .more-cont{
      left: 56px;
      top: 50px;
    }
  }
  .nav-cont{
    width: 100%;
    overflow: hidden;
  }
  
}
.home-user{
  width: 100%;
  box-sizing: border-box;
  padding: 20px;
  position: relative;
  .user-img{
    text-align: center;
    img{
      display: inline-block;
      height: 80px;
      width: 80px;
      border-radius: 50%;
      text-align: center;
      line-height: 80px;
      font-weight: 700;
    }
  }
  .user-img-mini{
    text-align: center;
    position: relative;
    height: 40px;
    .user-img-mini-in{
      position: absolute;
      height: 64px;
      width: 64px;
      left: -20px;
      top: -10px;
      text-align: center;
    }
    img{
      display: inline-block;
      height: 56px;
      width: 56px;
      border-radius: 50%;
      text-align: center;
      line-height: 40px;
      font-weight: 700;
    }
  }
  .user-info{
    .name{
      text-align: center;
      font-size: 14px;
      font-weight: 700;
      line-height: 32px;
      height: 32px;
      padding: 0 10px;
    }
  }
  .more{
    position: absolute;
    bottom: 20px;
    right: 0px;
    font-size: 16px;
    font-weight: 700;
    cursor: pointer;
    color: #a0afba;
    line-height: 32px;
    width: 32px;
    text-align: center;
    padding-right: 8px;
  }
}

.home-body{
  flex: 10;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  box-sizing: border-box;
  padding-top: 40px;
  position: relative;
}
.body-tabs{
  position: absolute;
  height: 40px;
  width: 100%;
  left: 0;
  top: 0px;
  z-index: 60;
  line-height: 40px;
  padding: 0 44px 0 0px;
  background-color: #F5F5F5;
  box-sizing: border-box;
  box-shadow: 0 1px 2px 0 rgba(0,0,0,.1);
}
.tabs-left{
  position: absolute;
  left: 0;
  top: 0;
  width: 40px;
  text-align: center;
  box-sizing: border-box;
  border-left: 1px solid #F2F6FC;
  border-right: 1px solid #F2F6FC;
  cursor: pointer;
}
.tabs-home{
  position: absolute;
  left: 40px;
  top: 0;
  width: 40px;
  text-align: center;
  box-sizing: border-box;
  border-right: 1px solid #F2F6FC;
  cursor: pointer;
  border-bottom: 2px solid transparent;
  height: 40px;
  &:hover{
    border-bottom-color: #2777e9;
  }
}
.tabs-home-on{
  border-bottom-color: #2777e9;
}
.tabs-right{
  position: absolute;
  overflow: hidden;
  right: 0;
  top: 0;
  width: 42px;
  text-align: center;
  box-sizing: border-box;
  cursor: pointer;
  font-size: 18px;
  color: #0072CB;
}
.tabs-user{
  right: 0px;
  height: 40px;
  box-sizing: border-box;
  padding-top: 4px;
  img{
    box-sizing: border-box;
    display: block;
    margin: 0 auto;
    height: 32px;
    width: 32px;
    border-radius: 50%;
    border: 2px solid $color-theme1;
  }
}
.tabs-cont{
  overflow: hidden;
  position: relative;
  height: 40px;
  .tabs-list{
    height: 40px;
    white-space: nowrap;
    transition: all .2s;
    position: absolute;
    top: 0;
    left: 0;
    line-height: 40px;
    padding-right: 10px;
  }
}


.body-cont{
  height: 100%;
  width: 100%;
  overflow: auto;
  position: relative;
  background-color: #fff;
}

.more-cont{
  ul{
    text-align: center;
    li{
      font-size: 14px;
      padding: 0 20px;
      height: 36px;
      line-height: 36px;
      cursor: pointer;
      &:hover{
        color: #0072CB;
      }
    }
  }
}


.tag{
  animation: flipInY;
  animation-duration: 0.6s;
  &:hover{
    transition: all 0.3s;  
    transform: scale(1.1);
  }
}
</style>

<style lang="scss">
// 菜单样式
.home-nav{
  .el-menu{
    border-right: 0;
  }
  .el-submenu__title{
    color: #a0afba;
    .iconfont{
      font-size: 12px;
    }
  }
  .el-menu-item{
    // border-left: 4px solid transparent;
    color: #a0afba;
  }
  .el-menu-item.is-active{
    border-left-color: #2777e9;
  }
  // 菜单图表
  .el-submenu__title i{
    color: #8ea8bf;
  }
  .el-menu-item i{
    color: #8ea8bf;
  }
}
// 标签
.body-tabs{
  .el-tag{
    cursor: pointer;
    margin-left: 10px;
  }
}

</style>